import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.75 9.937V8.063c0-1.11-.78-1.97-1.723-2.508-.964-.55-2.246-.867-3.62-.867-1.376 0-2.657.316-3.621.867-.943.539-1.723 1.397-1.724 2.507v8.778a1.538 1.538 0 0 0 .014.174c.013.105.037.245.082.41.092.328.272.757.625 1.181.728.873 2.062 1.582 4.404 1.582h14.75V9.938H12.75Zm-8.22-3.08c-.713.408-.963.857-.967 1.196 0 .006 0 .017.003.034a1.576 1.576 0 0 0 .118.406c.137.25.401.52.846.774.696.398 1.705.668 2.86.67h.032c1.156-.002 2.165-.272 2.86-.67.72-.41.968-.865.968-1.204 0-.34-.248-.794-.968-1.205-.698-.4-1.714-.67-2.876-.67s-2.177.27-2.876.67Zm2.657 4.58h13.25v7.25H18v-2.75h-1.5v2.75h-2.438v-2.75h-1.5v2.75h-2.437v-2.75h-1.5v2.75H7.187c-2.032 0-2.885-.603-3.251-1.042a1.677 1.677 0 0 1-.333-.623 1.26 1.26 0 0 1-.04-.22v-6.253c.79.526 1.95.889 3.624.889Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }